import { Slider } from "../../../components";
import { EstimationLineForm } from "./EstimationLineForm";
import { ICONS } from "../../../components";

export const AddPartSlider = ({ open, onAfterOpen, onClose, ticket, onSubmit }) => (
  <Slider
    title={ICONS.PLUS}
    open={open}
    onAfterOpen={onAfterOpen}
    header={
      <>
        <span className="me-3">{ICONS.PLUS}</span>
        <span>Add Part Requests</span>
      </>
    }
  >
    <EstimationLineForm ticket={ticket} onSubmit={onSubmit} />
  </Slider>
);
